// extracted by mini-css-extract-plugin
export default {"custom_select":"Select_custom_select__CVJTg"};